<template>
  <List/>
</template>

<script>
import List from '@/components/orders/List'

export default {
  components: { List }
}
</script>
